import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

/**
 * Quem não pode escrever não vê os botões — mas o endereço digitado à mão abria a página de
 * escrita na mesma, para só falhar ao gravar. Sem a permissão, volta-se à lista de ocorrências.
 */
export const permissionGuard = (permission: string): CanActivateFn => (route) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (auth.can(permission)) return true;
  return router.createUrlTree(['/', route.paramMap.get('tenant') ?? auth.currentTenant(), 'ocorrencias']);
};
